var Industry = "業界";
var Aerospace = "航空宇宙";
var Agriculture = "農業";
var Automotive = "自動車";
var Education = "教育機関";
var Gaming = "ゲーム";
var Government = "官公庁、地方公共団体および関連サービス";
var Healthcare = "ヘルスケア";
var Hospitality = "接客";
var Manufacturing = "製造";
var Mining = "鉱業";
var Other = "その他";
var Retail = "小売";
var Telecommunications = "通信";
var Travel = "旅行";
var industry = {
	Industry: Industry,
	Aerospace: Aerospace,
	Agriculture: Agriculture,
	Automotive: Automotive,
	"Computers & electronics": "コンピュータとエレクトロニクス",
	"Consumer goods": "消費財",
	Education: Education,
	"Financial services": "金融サービス",
	Gaming: Gaming,
	Government: Government,
	Healthcare: Healthcare,
	Hospitality: Hospitality,
	"Life sciences": "ライフサイエンス",
	Manufacturing: Manufacturing,
	"Marketing & advertising": "マーケティングと広告",
	"Media & entertainment": "メディアとエンターテインメント",
	Mining: Mining,
	"Non-profit organization": "非営利組織",
	"Oil & gas": "石油とガス",
	Other: Other,
	"Power & utilities": "電力と公益事業",
	"Professional services": "プロフェッショナルサービス",
	"Real estate & construction": "不動産 & 建設",
	Retail: Retail,
	"Software & internet": "ソフトウェア & インターネット",
	Telecommunications: Telecommunications,
	"Transportation & logistics": "運輸 & ロジスティクス",
	Travel: Travel,
	"Wholesale & distribution": "卸売 & 流通"
};

export { Aerospace, Agriculture, Automotive, Education, Gaming, Government, Healthcare, Hospitality, Industry, Manufacturing, Mining, Other, Retail, Telecommunications, Travel, industry as default };
